import React from "react";
import { CookieManager } from "react-cookie-manager";
import "../styles/cookie-consent.css";

export default function CookieConsentProvider({ children }) {
  return (
    <CookieManager
      cookieKey="smp-cookie-consent"
      expirationDays={365}
      displayType="banner"
      theme="light"
      showManageButton
      enableFloatingButton
      privacyPolicyUrl="/privacy-policy/"
      googleConsentMode
      translations={{
        title: "Your cookie preferences",
        message:
          "We use cookies for site functionality, analytics and marketing. You can save your preferences below.",
        buttonText: "Accept all",
        declineButtonText: "Decline optional cookies",
        manageButtonText: "Cookie settings",
        manageTitle: "Cookie settings",
        manageMessage:
          "Save your preferences for analytics, social and advertising cookies. Essential cookies and CAPTCHA protection are always enabled.",
        manageEssentialSubtitle:
          "Required for site functionality, saved preferences and CAPTCHA spam protection.",
        manageSaveButtonText: "Save preferences",
        privacyPolicyText: "Privacy policy",
      }}
    >
      {children}
    </CookieManager>
  );
}

// Gatsby also applies wrapRootElement to Head exports. Keep this UI in the
// page wrapper so Head rendering cannot mount a second consent portal.
export const wrapPageElement = ({ element }) => (
  <CookieConsentProvider>{element}</CookieConsentProvider>
);
